import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getProvidersEmplpoyees = createAsyncThunk(
  "providers/getProvidersEmplpoyees",
  async ({ id, token }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/get-workers-of-provider/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      console.log("response", res);
      return res.data.data; // return only the data object
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

const providersEmployeesSlice = createSlice({
    name: "providersEmployees",
    initialState: {
      providersEmployeesData: [],
      loading: false,
      error: null,
      message: "",
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProvidersEmplpoyees.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProvidersEmplpoyees.fulfilled, (state, action) => {
                state.loading = false;
                state.providersEmployeesData = action.payload;
            })
            .addCase(getProvidersEmplpoyees.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    },
});

export default providersEmployeesSlice.reducer;
